export default "__VITE_ASSET__cAp1B9vI__"